import { Component, Input } from '@angular/core';
import {
  CadastroContratoDto,
  MaritalStatus,
  MeioPagamento,
  OwnerDto,
  PropertyDto,
  PropertyUsage
} from '@usucampeao/lib-reurb-simplificado';
import { TipoContract } from '../../../enums';

@Component({
  selector: 'usu-procuracao-reurb-averbacao-v3',
  templateUrl: './procuracao-reurb-averbacao-v3.component.html',
  styleUrls: ['./procuracao-reurb-averbacao-v3.component.scss'],
})
export class ProcuracaoReurbAverbacaoV3Component {
  @Input() cadastro!: CadastroContratoDto;
  @Input() proprietario!: Partial<OwnerDto>;
  @Input() conjuge!: Partial<OwnerDto>;
  @Input() imovel!: Partial<PropertyDto>;
  @Input() tipo: TipoContract;

  public get somenteAverbacao(): boolean {
    return this.tipo === TipoContract.PROCURACAO_AVERBACAO;
  }

  public get meioPagamento(): typeof MeioPagamento {
    return MeioPagamento
  }

  public get imovelTipo(): typeof PropertyUsage {
    return PropertyUsage
  }

  public get maritalStatus(): typeof MaritalStatus {
    return MaritalStatus
  }

  public get mostrarDadosConjuge(): boolean {
    return !!this.conjuge && this.proprietario?.maritalStatus === MaritalStatus.MARRIED;
  }
}
